import { useRouter } from "next/router";
import AboutTitle from "../../../public/img/cheersup-v2/about-title.svg";

const AboutEn = () => {
  return (
    <div>
      <div className="text-[24px] font-medium leading-[38px] tracking-[0.01em]">
        Cheers UP{" "}
        <img className="align-middle" src="/img/cheersup-v2/cup.svg" alt="" />{" "}
        <img
          className="align-middle"
          src="/img/cheersup-v2/about-us-arrow.svg"
          alt=""
        />{" "}
        is an official IP authorized by bilibili (NASDAQ: BILI), a media
        platform with more than 330 million monthly active users worldwide.
        BILIBILI entrusted CryptoNatty{" "}
        <img
          className="align-middle"
          src="/img/cheersup-v2/cryptonatty.svg"
          alt=""
        />{" "}
        <img
          className="align-middle"
          src="/img/cheersup-v2/about-us-arrow.svg"
          alt=""
        />{" "}
        to launch this collection of 5000 programmatically generated NFTs that
        serve not only as unique avatars but also pass cards that grant you
        access to the Cheers UP Universe.
        <br />
        <br />
        By Joining the Cheers UP Family:
        <br />
        1) enjoy exclusive benefits on bilibili App and from other partners
        <br />
        2) redeem special gifts via our featured brewing & staking system
        <br />
        3) receive more surprises in the Cheers UP community
        <br />
        As the Cheers UP universe expands, you can expect much more
        possibilities!
        <br />
        <br />
        Whether happy or sad, easy or tough, be brave and cheer with us.{" "}
        <img
          className="align-middle"
          src="/img/cheersup-v2/cheers.svg"
          alt=""
        />{" "}
        <img
          className="align-middle"
          src="/img/cheersup-v2/about-us-arrow.svg"
          alt=""
        />{" "}
        (゜-゜)つロcheers!
      </div>
    </div>
  );
};

const AboutCn = () => {
  return (
    <div>
      <div className="text-[24px] font-medium leading-[38px] tracking-[0.01em]">
        Cheers UP{" "}
        <img className="align-middle" src="/img/cheersup-v2/cup.svg" alt="" />{" "}
        <img
          className="align-middle"
          src="/img/cheersup-v2/about-us-arrow.svg"
          alt=""
        />{" "}
        是由哔哩哔哩官方进行 IP 授权、由 CryptoNatty{" "}
        <img
          className="align-middle"
          src="/img/cheersup-v2/cryptonatty.svg"
          alt=""
        />{" "}
        <img
          className="align-middle"
          src="/img/cheersup-v2/about-us-arrow.svg"
          alt=""
        />{" "}
        发行的 NFT 系列。共包含 5000款 NFT
        形象，均由计算机程序随机生成，他们不仅仅是独特的形象，更是 Cheers UP
        宇宙中的通行证。
        <br />
        <br />
        加入Cheers UP大家庭
        <br />
        1) 享受在bilibili App以及合作生态场景内的特殊权益
        <br />
        2) 通过项目特色的酿造/质押系统换取惊喜奖励
        <br />
        3) 参与社区不定期的有趣福利
        <br />
        而随着Cheers UP宇宙的扩展，可以期待源源不断的可能性！
        <br />
        <br />
        无论快乐或悲伤，顺遂或险阻，我们都要勇敢的举杯庆祝！{" "}
        <img
          className="align-middle"
          src="/img/cheersup-v2/cheers.svg"
          alt=""
        />{" "}
        <img
          className="align-middle"
          src="/img/cheersup-v2/about-us-arrow.svg"
          alt=""
        />{" "}
        (゜-゜)つロ干杯！
      </div>
    </div>
  );
};

export const AboutUs = () => {
  const { locale } = useRouter();
  return (
    <div className="text-white mt-[160px] container mx-auto 2xl:w-[1440px]">
      <div className="mb-[60px]">
        <AboutTitle />
      </div>

      {locale === "cn" ? <AboutCn /> : <AboutEn />}
    </div>
  );
};
